const SKU_DATA =  {
  "defaults": { "image_base": "https://image.rakuten.co.jp/maruishi-fab/cabinet" },
  "variants": [
    {
      "variant_id": "51914715136293",
      "variant_name": "Aセット",
      "variant_image": "/image5/admission-kit-13.jpg",
      "price": "6,500",
      "comment": "",
      "category": "other",
      "order": "6",
      "item_url": "admission-kit"
    },
    {
      "variant_id": "51914715169061",
      "variant_name": "Bセット",
      "variant_image": "/image5/admission-kit-14.jpg",
      "price": "6,500",
      "comment": "",
      "category": "base",
      "order": "1",
      "item_url": "admission-kit"
    },
    {
      "variant_id": "51914715201829",
      "variant_name": "Cセット",
      "variant_image": "/image5/admission-kit-15.jpg",
      "price": "6,500",
      "comment": "",
      "category": "girl",
      "order": "1",
      "item_url": "admission-kit"
    },
    {
      "variant_id": "51914715234597",
      "variant_name": "Dセット",
      "variant_image": "/image5/admission-kit-16.jpg",
      "price": "6,500",
      "comment": "",
      "category": "other",
      "order": "1",
      "item_url": "admission-kit"
    },
    {
      "variant_id": "51914751115557",
      "variant_name": "Eセット",
      "variant_image": "/image5/admission-kit-17.jpg",
      "price": "6,500",
      "comment": "",
      "category": "boy",
      "order": "4",
      "item_url": "admission-kit"
    },
    {
      "variant_id": "51914715267365",
      "variant_name": "Fセット",
      "variant_image": "/image5/admission-kit-18.jpg",
      "price": "6,500",
      "comment": "",
      "category": "other",
      "order": "2",
      "item_url": "admission-kit"
    },
    {
      "variant_id": "51914715300133",
      "variant_name": "Gセット",
      "variant_image": "/image5/admission-kit-19.jpg",
      "price": "6,500",
      "comment": "",
      "category": "other",
      "order": "5",
      "item_url": "admission-kit"
    },
    {
      "variant_id": "51914715332901",
      "variant_name": "Hセット",
      "variant_image": "/image5/admission-kit-20.jpg",
      "price": "6,500",
      "comment": "",
      "category": "other",
      "order": "5",
      "item_url": "admission-kit"
    },
    {
      "variant_id": "51914715365669",
      "variant_name": "Iセット",
      "variant_image": "/image5/admission-kit-21.jpg",
      "price": "6,500",
      "comment": "",
      "category": "girl",
      "order": "5",
      "item_url": "admission-kit"
    },
    {
      "variant_id": "51914715398437",
      "variant_name": "Jセット",
      "variant_image": "/image5/admission-kit-22.jpg",
      "price": "6,500",
      "comment": "",
      "category": "boy",
      "order": "2",
      "item_url": "admission-kit"
    },
    {
      "variant_id": "51914715431205",
      "variant_name": "Kセット",
      "variant_image": "/image5/admission-kit-23.jpg",
      "price": "6,500",
      "comment": "",
      "category": "other",
      "order": "3",
      "item_url": "admission-kit"
    },
    {
      "variant_id": "51914715463973",
      "variant_name": "Lセット",
      "variant_image": "/image5/admission-kit-24.jpg",
      "price": "6,500",
      "comment": "",
      "category": "boy",
      "order": "5",
      "item_url": "admission-kit"
    },
    {
      "variant_id": "51914715496741",
      "variant_name": "Mセット",
      "variant_image": "/image5/admission-kit-25.jpg",
      "price": "6,500",
      "comment": "",
      "category": "boy",
      "order": "1",
      "item_url": "admission-kit"
    },
    {
      "variant_id": "51914715529509",
      "variant_name": "Nセット",
      "variant_image": "/image5/admission-kit-26.jpg",
      "price": "6,500",
      "comment": "",
      "category": "other",
      "order": "4",
      "item_url": "admission-kit"
    },
    {
      "variant_id": "51914715562277",
      "variant_name": "Oセット",
      "variant_image": "/image5/admission-kit-27.jpg",
      "price": "6,500",
      "comment": "",
      "category": "girl",
      "order": "2",
      "item_url": "admission-kit"
    },
    {
      "variant_id": "51914715595045",
      "variant_name": "Pセット",
      "variant_image": "/image5/admission-kit-28.jpg",
      "price": "6,500",
      "comment": "",
      "category": "girl",
      "order": "3",
      "item_url": "admission-kit"
    },
    {
      "variant_id": "51914715627813",
      "variant_name": "Qセット",
      "variant_image": "/image5/admission-kit-29.jpg",
      "price": "6,500",
      "comment": "",
      "category": "girl",
      "order": "4",
      "item_url": "admission-kit"
    },
    {
      "variant_id": "51914715660581",
      "variant_name": "Rセット",
      "variant_image": "/image5/admission-kit-30.jpg",
      "price": "6,500",
      "comment": "",
      "category": "boy",
      "order": "3",
      "item_url": "admission-kit"
    },
    {
      "variant_id": "51917567590693",
      "variant_name": "Sセット",
      "variant_image": "/image5/admission-kit-31.jpg",
      "price": "6,500",
      "comment": "",
      "category": "other",
      "order": "7",
      "item_url": "admission-kit"
    }
  ]
};

jQuery(function ($) {

  const data = SKU_DATA;
  const base = data.defaults.image_base;
  const variants = data.variants;

  // 送信用フォーム（units=1固定）
  const $form = $("#cartForm");
  const $var = $form.find('input[name="id"]');

  // テンプレ
  const $tpl = $("#admsItemTpl");

  // グルーピング（古いブラウザも考えるなら ||= は使わないのが安全）
  const grouped = {};
  $.each(variants, function (_, v) {
    if (!grouped[v.category]) grouped[v.category] = [];
    grouped[v.category].push(v);
  });

  // DOM生成
  $.each(grouped, function (cat, arr) {
    arr.sort(function (a, b) { return (+a.order) - (+b.order); });

    const $list = $("#" + cat).find(".adms__list");
    $list.empty();

    $.each(arr, function (_, v) {
      const imgUrl = (v.variant_image.indexOf("http") === 0)
        ? v.variant_image
        : (base + v.variant_image);

      const $li = $tpl.clone(false, false)
        .removeAttr("id")
        .attr("data-variant_id", v.variant_id)
        .addClass("no" + v.order);

      $li.find("img").first()
        .attr("src", imgUrl)
        .attr("alt", v.variant_name);

      $li.find(".adms-set__name").text(v.variant_name);
      $li.find(".adms-set__comment").text(v.comment);
      $li.find(".adms-set__price").text("￥" + v.price);
      $list.append($li);
    });
  });

  // ✅ Swiperはここで1回だけ
  initSwipers();

  // かご投入（個数1固定）
  $(document).on("click", ".adms__item .add-to-cart", function () {
    const $btn = $(this);
    if ($btn.data("submitting")) return;

    const variantId = $btn.closest(".adms__item").data("variant_id");

    $btn.data("submitting", 1).prop("disabled", true);

    // $item.val(String(SKU[variantId]));
    $var.val(String(variantId));

    $form[0].submit();

    setTimeout(function () {
      $btn.data("submitting", 0).prop("disabled", false);
    }, 4000);
  });
});

// メニュー開く（SPだけ意味ある）
$(document).on('click', '.ads-menu__open', function (e) {
  e.preventDefault();
  $('body').addClass('is-menu-open');
});

// メニュー閉じる（SPだけ意味ある）
$(document).on('click', '.adms-memu__close', function (e) {
  e.preventDefault();
  $('body').removeClass('is-menu-open');
});

// B. ページ内リンク（SPは閉じる＋bodyスクロール、PCは.adms__mainスクロール）
$(document).on('click', '.adms-memu a[href^="#"]', function (e) {
  const href = $(this).attr('href');
  if (href === '#') return;

  const isSp = window.matchMedia('(max-width: 768px)').matches;

  // SP：標準ジャンプ（スムースなし）＋メニュー閉じる
  if (isSp) {
    $('body').removeClass('is-menu-open');
    return; // preventDefaultしない
  }

  // PC：中央スクロールはJSでやる必要がある
  const $target = $(href);
  if (!$target.length) return;

  e.preventDefault();

  const $scrollArea = $('.adms__main');
  const targetTopInScrollArea =
    $target.offset().top - $scrollArea.offset().top + $scrollArea.scrollTop();

  $scrollArea.stop(true).animate(
    { scrollTop: targetTopInScrollArea },
    250,
    'swing'
  );
});


// リサイズ事故を完全に潰す
$(function () {
  const mqPc = window.matchMedia('(min-width: 769px)');

  function syncMenuState() {
    if (mqPc.matches) {
      // PCは常時表示なので、SP用の「開いてる状態」を消す
      $('body').removeClass('is-menu-open');
    }
  }

  syncMenuState();

  if (mqPc.addEventListener) {
    mqPc.addEventListener('change', syncMenuState);
  } else {
    mqPc.addListener(syncMenuState);
  }
});

//PCのみアクティブな箇所に印付ける
// PCのみ：中央スクロール位置で active を付け替える（確実版）
$(function () {
  const mqPc = window.matchMedia('(min-width: 769px)');
  const $scrollArea = $('.adms__main');
  const $menuItems = $('.adms-memu__item[data-anchor]');

  function setActive(anchor) {
    $menuItems.removeClass('active');
    $menuItems.filter('[data-anchor="' + anchor + '"]').addClass('active');
  }

  function getTargets() {
    return $menuItems.map(function () {
      const id = $(this).data('anchor');
      return $('#' + id);
    }).get().filter(function ($el) {
      return $el && $el.length;
    });
  }

  function updateActive() {
    if (!mqPc.matches) return;
    if (!$scrollArea.length) return;

    const targets = getTargets();
    if (!targets.length) return;

    const scrollTop = $scrollArea.scrollTop();
    const areaTop = $scrollArea.offset().top;

    // 「スクロール領域の上から少し下」を基準点にする（切り替え位置）
    const pivot = scrollTop + 120;

    let currentId = targets[0].attr('id');
    let bestTop = -Infinity;

    targets.forEach(function ($sec) {
      const topInArea = $sec.offset().top - areaTop + scrollTop;
      if (topInArea <= pivot && topInArea > bestTop) {
        bestTop = topInArea;
        currentId = $sec.attr('id');
      }
    });

    setActive(currentId);
  }

  function initScrollSpy() {
    $menuItems.removeClass('active');

    if (!mqPc.matches) return;

    // スクロール時に更新（連打防止で requestAnimationFrame 使う）
    let ticking = false;
    $scrollArea.off('scroll._spy').on('scroll._spy', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        updateActive();
        ticking = false;
      });
    });

    // 初期反映
    updateActive();
  }

  initScrollSpy();

  // PC/SP切替でも壊れないように
  if (mqPc.addEventListener) mqPc.addEventListener('change', initScrollSpy);
  else mqPc.addListener(initScrollSpy);
});

function initSwipers() {
  $(".adms__list-wrapper.swiper").each(function (_, el) {
    const $wrap = $(el);

    // ナビ欲しいなら差し込み（不要ならここ丸ごと消してOK）
    if (!$wrap.find(".swiper-button-prev").length) {
      $wrap.append('<div class="swiper-button-prev"></div><div class="swiper-button-next"></div>');
    }

    new Swiper(el, {
      grabCursor: true,
      spaceBetween: 30,
      slidesPerView: 1.2,
      slidesOffsetBefore: 30,
      slidesOffsetAfter: 30,

      breakpoints: {
        768: { slidesPerView: 1.4 },
        1024: { slidesPerView: 1.4 }
      },

      navigation: {
        nextEl: $wrap.find(".swiper-button-next")[0],
        prevEl: $wrap.find(".swiper-button-prev")[0]
      },

      // ボタン2つある前提で誤爆減らす
      threshold: 12,
      preventClicks: true,
      preventClicksPropagation: true,
      touchStartPreventDefault: false
    });
  });
}

